<div class="st-topic-custom-fields-header">{{ languageSettings.PSTWebCustomizeTopicCard }}</div>
<div class="st-topic-custom-fields-body">
    <st-topic-item
        [data]="data()"
        [isReadOnly]="true"
        [preview]="true"
        [customCardItems]="viewStateCustomCardItems"
        [class.has-dynamic-controls]="true" />
    <div class="st-topic-custom-fields-body-field-container">
        <st-combo-box
            class="st-topic-custom-fields-body-field-container-field"
            [label]="languageSettings.PSTWebSelectFieldLabel"
            [placeholder]="languageSettings.PSTWebSelectFieldLabel"
            [itemList]="getCustomFieldsList()"
            [value]="viewStateCustomCardItems?.[0]?.ID"
            [addEmptyOption]="true"
            (changed)="selectionChanged($event, 0)" />
        <st-combo-box
            [label]="languageSettings.PSTWebSelectFieldLabel"
            [placeholder]="languageSettings.PSTWebSelectFieldLabel"
            [itemList]="getCustomFieldsList()"
            [value]="viewStateCustomCardItems?.[1]?.ID"
            [addEmptyOption]="true"
            (changed)="selectionChanged($event, 1)" />
        <st-combo-box
            [label]="languageSettings.PSTWebSelectFieldLabel"
            [placeholder]="languageSettings.PSTWebSelectFieldLabel"
            [itemList]="getCustomFieldsList()"
            [value]="viewStateCustomCardItems?.[2]?.ID"
            [addEmptyOption]="true"
            (changed)="selectionChanged($event, 2)" />
        <st-combo-box
            [label]="languageSettings.PSTWebSelectFieldLabel"
            [placeholder]="languageSettings.PSTWebSelectFieldLabel"
            [itemList]="getCustomFieldsList()"
            [value]="viewStateCustomCardItems?.[3]?.ID"
            [addEmptyOption]="true"
            (changed)="selectionChanged($event, 3)" />
    </div>
</div>
<div class="st-topic-custom-fields-footer">
    <button
        mat-button
        class="st-topic-custom-fields-cancel-btn"
        color="secondary"
        (click)="cancel()">
        {{ languageSettings.PSTWebCancelButtonLabel }}
    </button>
    <button
        mat-raised-button
        color="primary"
        (click)="apply()">
        {{ languageSettings.PSTWebApplyButtonLabel }}
    </button>
    <button
        *ngIf="isSuperVisor"
        mat-raised-button
        color="primary"
        (click)="saveAsTeamDefault()">
        {{ languageSettings.PSTWebSaveAsTeamDefault }}
    </button>
    <button
        *ngIf="isSuperVisor"
        mat-raised-button
        color="primary"
        (click)="saveAsEnterpriseDefault()">
        {{ languageSettings.PSTWebSaveAsEnterpriseDefault }}
    </button>
</div>
